import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs';
import { CalendarItems } from '../../Interface/CommonDataBaseInterface';
import { ConnectionProvider } from '../connection/connection';

@Injectable()
export class CalendarItemsStoreProvider {

	private db = new DatabaseProvider();
	public calendarsList: BehaviorSubject<any> = new BehaviorSubject([]);
	public calendarItemsList: BehaviorSubject<any> = new BehaviorSubject([]);

	public syncEventsObservable$: BehaviorSubject<any> = new BehaviorSubject(false);
	public syncEventError$: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor(
		private connection: ConnectionProvider
	) {
	}


	addToCalendars(calendarsList) {


		return new Promise((resolve, reject) => {

			this.db.calendars.clear().then(() => {

				this.db.calendars.bulkAdd(calendarsList).then((data) => {
					this.loadCalendarsList();
					resolve(data)
				}).catch((e) => {
					reject(e);
				});

			}).catch((e) => {
				reject(e);
			});

		});

	}

	loadCalendarsList() {

		return new Promise((resolve, reject) => {

			this.db.calendars.toArray().then((list) => {

				this.calendarsList.next(list);
				resolve(true);

			}).catch((e) => reject(e));

		});

	}


	addToCalendarItems(list) {

		return new Promise((resolve, reject) => {

			this.db.calendarItems.clear().then(() => {

				let calendarItemsList = this.manipulateCalendarItemsListBeforeInsert(list);
				this.db.calendarItems.bulkAdd(calendarItemsList).then((data) => {

					this.loadCalendarItemsList();
					resolve(data);

				}).catch((e) => {
					reject(e);
				});

			}).catch((e) => {
				reject(e);

			});

		});

	}

	add(item: CalendarItems) {


		return new Promise((resolve, reject) => [

			this.db.calendarItems.add(item).then((data) => {

				if (this.connection.isOnline()) {
					setTimeout(() => {
						this.syncEventsObservable$.next(true);
					}, 2000);
				} else {
					this.syncEventError$.next(true);
				}

				this.loadCalendarItemsList();
				resolve(data);
			}).catch((e) => {
				reject(e)
			})

		])


	}

	loadCalendarItemsList() {

		return new Promise((resolve, reject) => {

			this.db.calendarItems.toArray().then((list) => {

				// this.getUpdatedlist(list).then((updatedList) => {

				this.calendarItemsList.next(list);
				resolve(true);

				// }).catch((e) => reject(e));

			}).catch((e) => {
				reject(e);
			});

		});

	}

	getUpdatedlist(list: Array<any>) {

		return new Promise((resolve, reject) => {

			let array = [];

			if (list && list.length > 0) {

				list.forEach((tmpList) => {
					array.push(tmpList);
				});

				resolve(array);

			} else {
				resolve([]);
			}

		});


	}

	manipulateCalendarItemsListBeforeInsert(list) {

		let array = [];

		if (list && list.length > 0) {

			list.forEach((tmpList) => {

				tmpList["appstatus"] = "";
				array.push(tmpList);

			});


		}

		return array;

	}

	editCalendarEvent(id, item: CalendarItems) {

		return new Promise((resolve, reject) => {
			this.db.calendarItems.update(id, item).then((res) => {

				if (this.connection.isOnline()) {
					setTimeout(() => {
						this.syncEventsObservable$.next(true);
					}, 2000);
				} else {
					this.syncEventError$.next(true);
				}

				this.loadCalendarItemsList();
				resolve(res);
			}).catch((e) => {
				console.log(e);
				reject(e);
			});
		});

	}

}



// WEBPACK FOOTER //
// ./src/providers/calendar-items-store/calendar-items-store.ts